import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import uniqueId from 'lodash/uniqueId';

import Icon from '@components/Icon.vue';

import { faLightbulbOn } from '@icons/duotone/faLightbulbOn';

export interface Line {
  text: string;
  // subText?: string;
  tag?: string;
  classList?: string[];
  style?: Partial<CSSStyleDeclaration>;
}

export type Paragraph = string | Line | string[];

export interface Section {
  title?: string;
  paragraphs: Paragraph[];
  subText?: string;
}

/** `SiteDocument` component properties. */
export interface Props {
  sections: Section[];
}

interface KeyedSection extends Section {
  key: string;
  paragraphs: (string[] | Line)[];
}

/**
 * Map sections to keyed sections.
 *
 * @param sections Sections to map.
 * @returns Keyed sections.
 */

const __default__ = { name: 'SiteDocument' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    sections: null
  },
  setup(__props: any) {

const props = __props as {
  sections: Section[];
};



const items = computed(() => {
  return mapSections(props.sections);
});

const hasSubText = computed(() => {
  return items.value.some(({ subText }) => subText);
});

//#region Helper Functions

/**
 * Normalize the paragraphs of a section.
 *
 * @param paragraphs Paragraphs to normalize.
 * @returns Normalized paragraphs.
 */
function normalizeSectionParagraphs(paragraphs: Paragraph[]) {
  return paragraphs.map((value) => {
    if (Array.isArray(value)) return value;

    const line: Line =
      typeof value !== 'string' ? { ...value } : { text: value };

    line.tag = line.tag ?? 'p';
    line.classList = line.classList ?? [];
    line.style = line.style ?? {};

    return line;
  });
}

function mapSections(sections: Section[]) {
  return sections.map(({ title, paragraphs, subText }) => {
    const config: KeyedSection = {
      key: uniqueId(),
      paragraphs: normalizeSectionParagraphs(paragraphs),
    };

    if (title) {
      config.title = title;
    }

    if (subText) {
      config.subText = subText;
    }

    return config;
  });
}

//#endregion Helper Functions

return { __sfc: true,props, items, hasSubText, normalizeSectionParagraphs, mapSections, Icon, faLightbulbOn }
}

})